import { gql } from '@apollo/client';

export default gql`
  query getVouchersByTypeAndPeriod(
    $fromDate: String!
    $toDate: String!
    $active: Boolean!
    $description: String!
    $voucherType: String!
    $convertTotalToCurrency: Currency
    $pageSize: Int
  ) {
    getVouchersByTypeAndPeriod(
      fromDate: $fromDate
      toDate: $toDate
      active: $active
      description: $description
      voucherType: $voucherType
      convertTotalToCurrency: $convertTotalToCurrency
      pageSize: $pageSize
    ) {
      vouchers {
        id
        alias
        createdAt
        createdBy
        currency
        reference
        relatedBookingNumber
        value
      }
      totalCount
      totalValueInCurrency
    }
  }
`;
